import { render, staticRenderFns } from "./GestionTurnosSemanaWide.vue?vue&type=template&id=04ac4218&scoped=true"
import script from "./GestionTurnosSemanaWide.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemanaWide.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemanaWide.vue?vue&type=style&index=0&id=04ac4218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac4218",
  null
  
)

export default component.exports